import { useEffect, useState } from "react";
import { getAvailableLocales } from "./locales";

export function useAvailableLocales() {
  const [locales, setLocales] = useState<string[]>([]);

  useEffect(() => {
    getAvailableLocales().then(setLocales);
  }, []);

  return locales;
}
